<template>
  <nav>
    <v-app-bar
      :class="this.$route.name"
      class="py-1"
      text
      dark
      color="mdred"
      app
    >
      <template v-if="isMobile()">
        <v-app-bar-nav-icon
          class="gray--text"
          @click="drawer = !drawer"
        ></v-app-bar-nav-icon>
      </template>
      <v-toolbar-title
        class="text-uppercase text-center"
        style="min-width:230px;"
      >
        <span class="font-weight-light">
          École MD |
          <h1 class="subtitle-1">{{ findRouteName }}</h1>
        </span>
      </v-toolbar-title>

      <v-divider vertical></v-divider>

      <template v-if="!isMobile()">
        <v-toolbar-items v-for="item in menu" :key="item.text">
          <v-menu v-if="item.subItems" :close-on-click="true" :offset-y="true">
            <template v-slot:activator="{ on }">
              <v-btn class="ml-3" text v-on="on">
                <v-icon>{{ item.icon }}</v-icon>
                <span style="margin-left: 10px;">{{ item.text }}</span>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="subItem in item.subItems"
                :key="subItem.text"
                :to="subItem.route"
              >
                <v-list-item-title>
                  <v-icon>{{ subItem.icon }}</v-icon>
                  {{ subItem.text }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn v-else class="ml-3" router :to="item.route" text>
            <v-icon>{{ item.icon }}</v-icon>
            <span style="margin-left: 10px">{{ item.text }}</span>
          </v-btn>
        </v-toolbar-items>
      </template>

      <v-spacer></v-spacer>
      <template v-if="!connected">
        <v-btn router to="/connection" text>
          <template v-if="!isMobile()">
            <span>{{ $t("app.login.title") }}</span>
          </template>
          <v-progress-circular
            v-if="connecting || reconnecting"
            indeterminate
            color="primary"
            right
          ></v-progress-circular>
          <v-icon v-else right>account_circle</v-icon>
        </v-btn>
      </template>
      <template v-else>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on">
              <template v-if="!isMobile()">
                <span>{{ username }}</span>
              </template>
              <v-progress-circular
                v-if="connecting || reconnecting"
                indeterminate
                size="20"
                color="primary"
                right
              ></v-progress-circular>
              <!-- <v-icon v-else right>account_circle</v-icon> -->
              <DetectedSpeed
                v-else
                @network-type="handleNetworkIdentified"
                @network-speed="handleNetworkSpeed"
              >
                <span slot="unknown">
                  <v-icon right>wifi_off</v-icon>
                </span>
                <span slot="slow">
                  <v-icon right>account_circle</v-icon>
                </span>
                <span slot="fast">
                  <v-icon right>account_circle</v-icon>
                </span>
              </DetectedSpeed>
            </v-btn>
          </template>
          <v-list>
            <!--<v-list-item>
              <v-list-item-title>{{
                $t("app.navigation.settings")
              }}</v-list-item-title>
            </v-list-item>-->
            <v-list-item @click="logOut()">
              <v-list-item-title>{{
                $t("app.navigation.logout")
              }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-app-bar>

    <template v-if="isMobile()">
      <v-navigation-drawer
        v-model="drawer"
        disable-resize-watcher
        app
        class="blue-grey lighten-5"
      >
        <v-list>
          <div v-for="(item, i) in menu" :key="i">
            <v-list-item
              v-if="!item.subItems"
              :key="i"
              :to="item.route"
              class="v-list-item"
            >
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-title v-text="item.text" />
            </v-list-item>
            <v-list-group v-else :key="item.text" no-action>
              <template v-slot:activator>
                <v-list-item style="padding:0;">
                  <v-list-item-action>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-list-item
                v-for="subItem in item.subItems"
                :key="subItem.text"
                :to="subItem.route"
                style="padding-left:56px;"
              >
                <v-list-item-title>
                  <v-icon>{{ subItem.icon }}</v-icon>
                  {{ subItem.text }}
                </v-list-item-title>
              </v-list-item>
            </v-list-group>
          </div>
        </v-list>
      </v-navigation-drawer>
    </template>
  </nav>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import DetectedSpeed from "vue-identify-network";

export default {
  components: {
    DetectedSpeed
  },

  data() {
    return {
      drawer: false,
      menu: []
    };
  },

  computed: {
    ...mapState("site", ["connected", "connecting", "reconnecting", "denied"]),
    ...mapGetters("site", ["user"]),
    findRouteName: function() {
      return this.$route.name;
    },
    username: function() {
      if (this.connected) {
        return this.user.name;
      }
      return "User";
    }
  },

  watch: {
    connecting() {
      this.refreshMenu();
    },
    connected(val) {
      if (!val) {
        this.$store.dispatch("site/resetUser");
      }
      this.refreshMenu();
    }
  },

  mounted() {
    this.$nextTick(function() {
      this.refreshMenu();
    });
  },

  methods: {
    async logOut() {
      this.$store.dispatch("site/logout");
    },
    isMobile() {
      const bp = this.$vuetify.breakpoint;
      return bp.xs || bp.sm;
    },
    refreshMenu() {
      this.menu = [
        { icon: "dashboard", text: this.$t("app.navigation.home"), route: "/" }
      ];
      this.addUserTools();
      this.addManagementTools();
    },
    addUserTools() {
      const user = this.$store.getters["site/user"];
      if (user) {
        this.menu.push(
          ...[
            {
              icon: "event",
              text: this.$t("app.navigation.calendar"),
              route: "/schedule"
            },
            {
              icon: "folder",
              text: this.$t("app.navigation.classes"),
              route: "/classes"
            }
          ]
        );
      }
    },
    addManagementTools() {
      const user = this.$store.getters["site/user"];
      if (!!user && (user.role === "teacher" || user.role === "admin")) {
        this.menu.push({
          icon: "security",
          text: this.$t("app.navigation.management.header"),
          subItems: [
            {
              icon: "supervised_user_circle",
              text: this.$t("app.navigation.management.users"),
              route: "/users-management"
            },
            {
              icon: "class",
              text: this.$t("app.navigation.management.sessions"),
              route: "/sessions-management"
            }
          ]
        });
      }
    },

    handleNetworkIdentified(type) {},
    handleNetworkSpeed(speed) {}
  }
};
</script>

<style lang="scss" scoped>
/* lessons section */

.lessonNum {
  position: absolute;
  z-index: 1;
  padding: 6px;
  text-align: center;
  background-color: white;
}

/* navbar section */
.Accueil::after {
  top: 0px;
  content: "";
  opacity: 0.2;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
  background-color: hsl(34, 53%, 82%);
  background-image: repeating-linear-gradient(
      45deg,
      transparent 5px,
      hsla(197, 62%, 11%, 0.5) 5px,
      hsla(197, 62%, 11%, 0.5) 10px,
      hsla(5, 53%, 63%, 0) 10px,
      hsla(5, 53%, 63%, 0) 35px,
      hsla(5, 53%, 63%, 0.5) 35px,
      hsla(5, 53%, 63%, 0.5) 40px,
      hsla(197, 62%, 11%, 0.5) 40px,
      hsla(197, 62%, 11%, 0.5) 50px,
      hsla(197, 62%, 11%, 0) 50px,
      hsla(197, 62%, 11%, 0) 60px,
      hsla(5, 53%, 63%, 0.5) 60px,
      hsla(5, 53%, 63%, 0.5) 70px,
      hsla(35, 91%, 65%, 0.5) 70px,
      hsla(35, 91%, 65%, 0.5) 80px,
      hsla(35, 91%, 65%, 0) 80px,
      hsla(35, 91%, 65%, 0) 90px,
      hsla(5, 53%, 63%, 0.5) 90px,
      hsla(5, 53%, 63%, 0.5) 110px,
      hsla(5, 53%, 63%, 0) 110px,
      hsla(5, 53%, 63%, 0) 120px,
      hsla(197, 62%, 11%, 0.5) 120px,
      hsla(197, 62%, 11%, 0.5) 140px
    ),
    repeating-linear-gradient(
      135deg,
      transparent 5px,
      hsla(197, 62%, 11%, 0.5) 5px,
      hsla(197, 62%, 11%, 0.5) 10px,
      hsla(5, 53%, 63%, 0) 10px,
      hsla(5, 53%, 63%, 0) 35px,
      hsla(5, 53%, 63%, 0.5) 35px,
      hsla(5, 53%, 63%, 0.5) 40px,
      hsla(197, 62%, 11%, 0.5) 40px,
      hsla(197, 62%, 11%, 0.5) 50px,
      hsla(197, 62%, 11%, 0) 50px,
      hsla(197, 62%, 11%, 0) 60px,
      hsla(5, 53%, 63%, 0.5) 60px,
      hsla(5, 53%, 63%, 0.5) 70px,
      hsla(35, 91%, 65%, 0.5) 70px,
      hsla(35, 91%, 65%, 0.5) 80px,
      hsla(35, 91%, 65%, 0) 80px,
      hsla(35, 91%, 65%, 0) 90px,
      hsla(5, 53%, 63%, 0.5) 90px,
      hsla(5, 53%, 63%, 0.5) 110px,
      hsla(5, 53%, 63%, 0) 110px,
      hsla(5, 53%, 63%, 0) 140px,
      hsla(197, 62%, 11%, 0.5) 140px,
      hsla(197, 62%, 11%, 0.5) 160px
    );
}

.Horaire::after {
  top: 0px;
  content: "";
  opacity: 0.2;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
  background-color: hsl(34, 53%, 82%);
  background-image: repeating-linear-gradient(
      45deg,
      transparent 5px,
      hsla(197, 62%, 11%, 0.5) 5px,
      hsla(197, 62%, 11%, 0.5) 10px,
      hsla(5, 53%, 63%, 0) 10px,
      hsla(5, 53%, 63%, 0) 35px,
      hsla(5, 53%, 63%, 0.5) 35px,
      hsla(5, 53%, 63%, 0.5) 40px,
      hsla(197, 62%, 11%, 0.5) 40px,
      hsla(197, 62%, 11%, 0.5) 50px,
      hsla(197, 62%, 11%, 0) 50px,
      hsla(197, 62%, 11%, 0) 60px,
      hsla(5, 53%, 63%, 0.5) 60px,
      hsla(5, 53%, 63%, 0.5) 70px,
      hsla(35, 91%, 65%, 0.5) 70px,
      hsla(35, 91%, 65%, 0.5) 80px,
      hsla(35, 91%, 65%, 0) 80px,
      hsla(35, 91%, 65%, 0) 90px,
      hsla(5, 53%, 63%, 0.5) 90px,
      hsla(5, 53%, 63%, 0.5) 110px,
      hsla(5, 53%, 63%, 0) 110px,
      hsla(5, 53%, 63%, 0) 120px,
      hsla(197, 62%, 11%, 0.5) 120px,
      hsla(197, 62%, 11%, 0.5) 140px
    ),
    repeating-linear-gradient(
      135deg,
      transparent 5px,
      hsla(197, 62%, 11%, 0.5) 5px,
      hsla(197, 62%, 11%, 0.5) 10px,
      hsla(5, 53%, 63%, 0) 10px,
      hsla(5, 53%, 63%, 0) 35px,
      hsla(5, 53%, 63%, 0.5) 35px,
      hsla(5, 53%, 63%, 0.5) 40px,
      hsla(197, 62%, 11%, 0.5) 40px,
      hsla(197, 62%, 11%, 0.5) 50px,
      hsla(197, 62%, 11%, 0) 50px,
      hsla(197, 62%, 11%, 0) 60px,
      hsla(5, 53%, 63%, 0.5) 60px,
      hsla(5, 53%, 63%, 0.5) 70px,
      hsla(35, 91%, 65%, 0.5) 70px,
      hsla(35, 91%, 65%, 0.5) 80px,
      hsla(35, 91%, 65%, 0) 80px,
      hsla(35, 91%, 65%, 0) 90px,
      hsla(5, 53%, 63%, 0.5) 90px,
      hsla(5, 53%, 63%, 0.5) 110px,
      hsla(5, 53%, 63%, 0) 110px,
      hsla(5, 53%, 63%, 0) 140px,
      hsla(197, 62%, 11%, 0.5) 140px,
      hsla(197, 62%, 11%, 0.5) 160px
    );
}

.Cours::after {
  top: 0px;
  content: "";
  opacity: 0.2;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
  background-color: gray;
  background-image: repeating-linear-gradient(
    45deg,
    transparent,
    transparent 35px,
    rgba(255, 255, 255, 0.5) 35px,
    rgba(255, 255, 255, 0.5) 70px
  );
}

.Connection::after {
  top: 0px;
  content: "";
  opacity: 0.2;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  z-index: -1;
  background-color: hsl(2, 57%, 40%);
  background-image: repeating-linear-gradient(
      transparent,
      transparent 50px,
      rgba(0, 0, 0, 0.4) 50px,
      rgba(0, 0, 0, 0.4) 53px,
      transparent 53px,
      transparent 63px,
      rgba(0, 0, 0, 0.4) 63px,
      rgba(0, 0, 0, 0.4) 66px,
      transparent 66px,
      transparent 116px,
      rgba(0, 0, 0, 0.5) 116px,
      rgba(0, 0, 0, 0.5) 166px,
      rgba(255, 255, 255, 0.2) 166px,
      rgba(255, 255, 255, 0.2) 169px,
      rgba(0, 0, 0, 0.5) 169px,
      rgba(0, 0, 0, 0.5) 179px,
      rgba(255, 255, 255, 0.2) 179px,
      rgba(255, 255, 255, 0.2) 182px,
      rgba(0, 0, 0, 0.5) 182px,
      rgba(0, 0, 0, 0.5) 232px,
      transparent 232px
    ),
    repeating-linear-gradient(
      270deg,
      transparent,
      transparent 50px,
      rgba(0, 0, 0, 0.4) 50px,
      rgba(0, 0, 0, 0.4) 53px,
      transparent 53px,
      transparent 63px,
      rgba(0, 0, 0, 0.4) 63px,
      rgba(0, 0, 0, 0.4) 66px,
      transparent 66px,
      transparent 116px,
      rgba(0, 0, 0, 0.5) 116px,
      rgba(0, 0, 0, 0.5) 166px,
      rgba(255, 255, 255, 0.2) 166px,
      rgba(255, 255, 255, 0.2) 169px,
      rgba(0, 0, 0, 0.5) 169px,
      rgba(0, 0, 0, 0.5) 179px,
      rgba(255, 255, 255, 0.2) 179px,
      rgba(255, 255, 255, 0.2) 182px,
      rgba(0, 0, 0, 0.5) 182px,
      rgba(0, 0, 0, 0.5) 232px,
      transparent 232px
    ),
    repeating-linear-gradient(
      125deg,
      transparent,
      transparent 2px,
      rgba(0, 0, 0, 0.2) 2px,
      rgba(0, 0, 0, 0.2) 3px,
      transparent 3px,
      transparent 5px,
      rgba(0, 0, 0, 0.2) 5px
    );
}
</style>
